/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
// Above eslint rules are disabled because of using <a> in <SafeTranslate> component
import { FC, useEffect, useRef } from 'react'
import { PickerHandle } from 'rsuite'

import SearchInput from './SearchInput'
import SearchDropdownMenu, { DropdownMenuData } from './SearchDropdownMenu'
import useSearchState from './hooks/useSearchState'
import useSearchHandlers from './hooks/useSearchHandlers'
import ProductSearchProvider from '../../../Search/ProductSearchProvider'

import styles from '../../../../styles/Search.module.less'

export interface SearchBarProps {
  externalSearchCallback?: () => void
  brandList?: (DropdownMenuData & { id: string })[]
  className?: string
  graphicRenderCondition?: 'focus' | 'always'
  isLargeInput?: boolean
  collapsed?: boolean
}

const SearchBar: FC<SearchBarProps> = (props) => {
  const {
    externalSearchCallback = () => {},
    brandList = [],
    className = '',
    isLargeInput = false,
    collapsed = false,
  } = props

  // Custom hooks for state and handlers
  const { searchTerm, setSearchTerm, results, refine, typesenseQuery, locale } = useSearchState()

  const containerRef = useRef<HTMLDivElement>(null)
  const searchInputRef = useRef<PickerHandle>(null)

  const {
    handleEnterKeyPress,
    handleClearSearchClick,
    handleChange,
    handleSearchClick,
    handleMenuItemClick,
    handleSupplierClick,
  } = useSearchHandlers({
    searchTerm,
    setSearchTerm,
    refine,
    externalSearchCallback,
    searchInputRef,
    locale,
  })

  useEffect(() => {
    const searchInputElement = searchInputRef.current?.root?.getElementsByTagName('input')[0]
    if (isLargeInput && !collapsed) {
      searchInputElement?.focus()
    } else {
      searchInputElement?.blur()
    }
  }, [collapsed, isLargeInput])

  // Render dropdown menu content only
  const renderMenu = () => (
    <SearchDropdownMenu
      searchMenuData={results}
      searchTerm={searchTerm}
      brandList={brandList}
      onItemClick={handleMenuItemClick}
      onSupplierClick={handleSupplierClick}
      typesenseQuery={typesenseQuery}
      refine={refine}
    />
  )

  return (
    <ProductSearchProvider>
      <div
        ref={containerRef}
        className={`${styles['search-container']} ${className}`}
      >
        <SearchInput
          searchTerm={searchTerm}
          searchMenuData={results}
          isLargeInput={isLargeInput}
          collapsed={collapsed}
          containerRef={containerRef}
          searchInputRef={searchInputRef}
          onChange={handleChange}
          onKeyUp={handleEnterKeyPress}
          onClearClick={handleClearSearchClick}
          onSearchClick={handleSearchClick}
          renderMenu={renderMenu}
        />
        {isLargeInput && !collapsed ? (
          renderMenu()
        ) : null}
      </div>
    </ProductSearchProvider>
  )
}

export default SearchBar
